<template>
  <div class="createVehicle-container">
    <b-form @submit="submitForm" @reset="onReset" v-if="show">
      <b-row>
        <b-col cols="4">
          <b-card no-body>
            <b-card-header>
              <b-row class="align-items-center">
                <b-col>
                  <h3>Fahrzeugdaten</h3>
                </b-col>
                <b-col>
                  <b-button type="submit" size="sm" variant="success" class="float-right"><i
                    class="far fa-dot-circle"></i> Speichern
                  </b-button>
                  <b-button type="reset" size="sm" variant="danger" class="float-right mr-1"><i class="fa fa-ban"></i>
                    Reset
                  </b-button>
                </b-col>
              </b-row>
            </b-card-header>
            <b-card-body>
              <b-form-row>
                <b-col>
                  <b-form-group id="input-group-1" label="Kennzeichen:" label-for="input-1">
                    <b-form-input
                      id="input-1"
                      v-model="vehicleForm.registration_number"
                      required
                    ></b-form-input>
                  </b-form-group>
                </b-col>
              </b-form-row>
              <b-form-row>
                <b-col>
                  <b-form-group id="input-group-1" label="Marke:" label-for="input-1">
                    <b-form-input
                      id="input-1"
                      v-model="vehicleForm.manufacturer"
                      placeholder="Ford"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group id="input-group-1" label="Modell:" label-for="input-1">
                    <b-form-input
                      id="input-1"
                      v-model="vehicleForm.model"
                      placeholder="Transit"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
              </b-form-row>
              <b-form-row>
                <b-col>
                  <b-form-group id="input-group-1" label="Einsatzort:" label-for="input-1">
                    <b-form-select
                      id="input-1"
                      v-model="vehicleForm.area_id"
                      :options="areas"
                      value-field="id"
                      text-field="name"
                    >
                      <template v-slot:first>
                        <option value="" disabled>-- Bitte auswählen --</option>
                      </template>
                    </b-form-select>
                  </b-form-group>
                </b-col>
              </b-form-row>
              <b-form-row>
                <b-col>
                  <b-form-group id="input-group-1" label="Fahrer:" label-for="input-1">
                    <b-form-select
                      id="input-1"
                      v-model="vehicleForm.driver_id"
                      :options="drivers"
                      value-field="id"
                      text-field="full_name"
                    >
                      <template v-slot:first>
                        <option value="" disabled>-- Bitte auswählen --</option>
                      </template>
                    </b-form-select>
                  </b-form-group>
                </b-col>
              </b-form-row>
            </b-card-body>
          </b-card>
          <!--<TrackerCard id="79316487-c601-4e32-8867-7a953a5006ce"></TrackerCard>-->
        </b-col>
        <b-col cols="4">
          <!--<b-card no-body>
            <b-card-header>
              <h3>Einsatzort</h3>
            </b-card-header>
            <b-card-body>
              <b-table bordered
                       fixed
                       responsive
                       style="overflow-y: auto;"
                       :items="areaTableData"
                       :fields="areaTableFields"
              >
                <template v-slot:cell(actions)="data">
                  <div class="text-center">
                    <b-button-group>
                      <b-button variant="warning" :to="'/vehicles/edit/' + data.item.id">
                        <i class="fas fa-pencil-alt"></i>
                      </b-button>
                      <b-button variant="danger" :to="'/vehicles/edit/' + data.item.id">
                        <i class="fas fa-times"></i>
                      </b-button>
                    </b-button-group>
                  </div>
                </template>
              </b-table>
            </b-card-body>
          </b-card>
          <b-card no-body>
            <b-card-header>
              <h3>Fahrer</h3>
            </b-card-header>
            <b-card-body>
              <b-table bordered
                       fixed
                       :items="areaTableData"
                       :fields="areaTableFields"
              >
                <template v-slot:cell(actions)="data">
                  <div class="text-center">
                    <b-button-group>
                      <b-button variant="warning" :to="'/vehicles/edit/' + data.item.id">
                        <i class="fas fa-pencil-alt"></i>
                      </b-button>
                      <b-button variant="danger" :to="'/vehicles/edit/' + data.item.id">
                        <i class="fas fa-times"></i>
                      </b-button>
                    </b-button-group>
                  </div>
                </template>
              </b-table>
            </b-card-body>
          </b-card>-->
        </b-col>
        <!--<b-col cols="4">
          <b-card no-body>
            <b-card-header>
              <h3>Standort</h3>
            </b-card-header>
            <b-card-body>
              MAP AKTUELLER STANDORT
            </b-card-body>
          </b-card>
        </b-col>-->
      </b-row>
    </b-form>
  </div>
</template>

<script>
    import TrackerCard from "./TrackerCard";
    import {fetchVehicle} from "@/api/vehicle";
    import Resource from '@/api/resource';
    import driverHistorieList from "../../vehicleManagement/vehicle/components/driverHistorieList";

    const vehicleResource = new Resource('vehicles');
    const areaResource = new Resource('areas');
    const driverResource = new Resource('drivers');

    const emptyForm = {
        registration_number: '',
        manufacturer: '',
        model: '',
        area_id: '',
    };

    export default {
        name: "VehicleDetail",
        props: {
            isEdit: {
                type: Boolean,
                default: false,
            },
            isNew: {
                type: Boolean,
                default: false,
            },
        },
        components: {
            'TrackerCard': TrackerCard,
            'DriverHistorie': driverHistorieList
        },
        data() {
            return {
                vehicleForm: Object.assign({}, emptyForm),
                fetchedData: null,
                areas: [],
                drivers: [],
                loading: false,
                driverListOptions: [],
                show: true,
                areaTableFields: [
                    {
                        key: 'area',
                        label: 'Einsatzort'
                    },
                    {
                        key: 'from',
                        label: 'von'
                    },
                    {
                        key: 'to',
                        label: 'bis'
                    },
                    {
                        key: 'actions',
                        label: 'Aktionen'
                    }
                ],
                areaTableData: [
                    {area: 'Rauenheim', from: '2019-12-31', to: ''},
                ]
            };
        },
        computed: {
            lang() {
                return this.$store.getters.language;
            },
        },
        created() {
            if (this.isNew) {
                this.$swal('Erfolg', 'Neues Fahrzeug wurde angelegt', 'success');
            }
            if (this.isEdit) {
                const id = this.$route.params && this.$route.params.id;
                this.fetchVehicleData(id);
            } else {
                this.vehicleForm = Object.assign({}, this.emptyForm);
            }
            this.fetchAreaList();
            this.fetchDriverList();
        },
        methods: {
            async fetchVehicleData(id) {
                this.loading = true;
                const {data} = await fetchVehicle(id);
                //this.driverForm = Object.assign({}, data);
                this.vehicleForm = data;
                this.fetchedData = Object.assign({}, data);
                if (!this.vehicleForm.hasOwnProperty('area_id')) {
                    this.vehicleForm.area_id = '';
                    this.fetchedData.area_id = '';
                }
                if (!this.vehicleForm.hasOwnProperty('driver_id')) {
                    this.vehicleForm.driver_id = '';
                    this.fetchedData.driver_id = '';
                }
                this.loading = false;
            },
            async fetchAreaList() {
                this.loading = true;
                const {data} = await areaResource.list();
                this.areas = data;
                this.loading = false;
            },
            async fetchDriverList() {
                this.loading = true;
                const {data} = await driverResource.list();
                this.drivers = data;
                this.loading = false;
            },
            async submitForm(event) {
                event.preventDefault();
                this.loading = true;
                if (this.isEdit) {
                    try {
                        await vehicleResource.update(this.fetchedData.id, this.vehicleForm);
                    } catch (e) {
                        this.$swal('Fehler', e.message, 'error');
                        this.loading = false;
                        return;
                    }
                    this.$swal('Erfolg', 'Änderungen erfolgreich gespeichert', 'success');
                } else {
                    let response = await vehicleResource.store(this.vehicleForm);
                    this.loading = false;
                    this.$router.push({ name: 'editVehicle', params: { id: response.data.id, isNew: true, isEdit: true } });
                }
                this.loading = false;
            },
            getRemoteDriverList(query) {
                driverSearch(query).then(response => {
                    if (!response.data.items) {
                        return;
                    }
                    this.driverListOptions = response.data.items.map(v => v.name);
                });
            },
            onReset(event) {
                event.preventDefault();
                // Reset our form values
                if (this.fetchedData !== null) {
                    this.vehicleForm = Object.assign({}, this.fetchedData);
                } else {
                    this.vehicleForm = Object.assign({}, this.emptyForm);
                }
                // Trick to reset/clear native browser form validation state
                this.show = false;
                this.$nextTick(() => {
                    this.show = true
                })
            }
        },
    }
</script>

<style scoped>
  /deep/ .table > tbody > tr > td {
    vertical-align: middle !important;
  }

  /deep/ /deep/ .scrollable {
    word-break: break-all;
    white-space: nowrap;
    max-height: 100px;
    overflow-y: auto;
  }
</style>
